const timeline = {
  filters: {
    status: {
      placeholder: 'Status',
      options: {
        'new': 'Novo',
        'in-route': 'Em rota',
        'sent': 'Enviado',
        'approved': 'Aprovado',
        'done': 'Ok',
        'canceled': 'Cancelado',
        'picking_up': 'Recolhimento',
      },
    },
    driver: 'Motorista',
    vehicle: 'Veículo',
    areas: 'Zonas',
    locations: 'Localizações',
    airportLocations: 'Localizações de Aeroporto',
    attributes: 'Atributo',
    driverShifts: 'Mostrar turnos de motorista',
    showUnassignedTrips: 'Mostrar viagens não atribuídas',
  },
  totals: {
    assigned: 'Atribuído',
    unassigned: 'Não Atribuído',
  },
  alerts: {
    etaChanged: 'O ESTIMATIVA para as paradas {{stopsIds}} da viagem {{tripId}} foi atualizado - O motorista foi notificado pelo sistema.',
  },
  assigenModal: {
    header: 'Atribuir motorista',
    description: 'Por favor, selecione um motorista/veículo da lista abaixo',
    driver: 'Escolher Motorista',
    vehicle: 'Selecionar Veículo',
    button: 'Atribuir',
  },
  toast: {
    toastSomethingWasWrong: 'Ocorreu um erro',
    assignedTrips: '{{numOfTrips}} viagens foi atribuída',
  },
  empty: 'Nenhuma viagem nas últimas 24 horas',
  driverInfo: {
    phoneNumber: 'Número de telefone',
    lettersLeft: 'Cartas Restantes',
    sendMessage: 'Enviar mensagem',
  },
  actions: {
    manualAssign: 'Atribuição manual',
    removeAssign: 'Remover atribuição',
    assignInsights: 'Atribuir insights',
  },
  tripInformation: {
    trip: 'Viagem #{{id}}',
  },
  stopInfo: {
    stopNumber: 'Parada #{{number}}',
    tripId: 'Viagem: {{id}}',
    pta: 'PTA: {{pta}}',
    eta: 'ETA: {{eta}}',
    totalReservations: '{{count}} reservas',
    pickupReservations: '{{count}} embarques',
    dropReservations: '{{count}} desembarques',
    totalSeats: '{{count}} assentos',
    table: {
      header: {
        reqAppt: 'Solic./Agend.',
        passenger: 'Passageiro',
        bookingId: 'ID da reserva',
        seats: 'Assentos',
        zones: 'Zonas',
        attributes: 'Atributos',
      },
      sections: {
        pickups: 'EMBARQUES',
        dropoffs: 'DESEMBARQUES',
        request: 'Solicitação',
        appt: 'Agendamento',
      },
    },
  },
};

export default timeline;
